export default __webpack_public_path__ + "static/media/bell.07a116d8.svg";